import axios from 'axios';

const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:4000/api',
});

axiosClient.interceptors.request.use((config) => {
  const sandboxToken = localStorage.getItem('sandboxToken');
  const trialToken = localStorage.getItem('trialToken');
  
  if (sandboxToken && config.url.includes('/sandbox')) {
    config.headers['x-trial-token'] = sandboxToken;
  } else if (trialToken) {
    config.headers['x-trial-token'] = trialToken;
  }
  
  const adminToken = localStorage.getItem('adminToken');
  if (adminToken && config.url.includes('/admin')) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  }
  return config;
});

export default axiosClient;
